// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"3d466d01","280":"93dead3d","494":"4d3f96e8"}[chunkId] + ".chunk.js";
};